// First Sound Sort — pick the picture whose word starts with the given sound.
export const FIRST_SOUND_ITEMS = [
  {
    sound: "b",
    letter: "B",
    correct: { word: "Ball", emoji: "⚽" },
    distractors: [
      { word: "Cat", emoji: "🐱" },
      { word: "Sun", emoji: "☀️" },
      { word: "Fish", emoji: "🐟" },
    ],
  },
  {
    sound: "s",
    letter: "S",
    correct: { word: "Sun", emoji: "☀️" },
    distractors: [
      { word: "Dog", emoji: "🐶" },
      { word: "Hat", emoji: "🎩" },
      { word: "Pig", emoji: "🐷" },
    ],
  },
  {
    sound: "c",
    letter: "C",
    correct: { word: "Cat", emoji: "🐱" },
    distractors: [
      { word: "Moon", emoji: "🌙" },
      { word: "Fish", emoji: "🐟" },
      { word: "Bee", emoji: "🐝" },
    ],
  },
  {
    sound: "d",
    letter: "D",
    correct: { word: "Dog", emoji: "🐶" },
    distractors: [
      { word: "Sun", emoji: "☀️" },
      { word: "Tree", emoji: "🌳" },
      { word: "Cup", emoji: "☕" },
    ],
  },
  {
    sound: "f",
    letter: "F",
    correct: { word: "Fish", emoji: "🐟" },
    distractors: [
      { word: "Cat", emoji: "🐱" },
      { word: "Moon", emoji: "🌙" },
      { word: "Ball", emoji: "⚽" },
    ],
  },
  {
    sound: "p",
    letter: "P",
    correct: { word: "Pig", emoji: "🐷" },
    distractors: [
      { word: "Sun", emoji: "☀️" },
      { word: "Cake", emoji: "🎂" },
      { word: "Bee", emoji: "🐝" },
    ],
  },
  {
    sound: "m",
    letter: "M",
    correct: { word: "Moon", emoji: "🌙" },
    distractors: [
      { word: "Dog", emoji: "🐶" },
      { word: "Fish", emoji: "🐟" },
      { word: "Hat", emoji: "🎩" },
    ],
  },
  {
    sound: "t",
    letter: "T",
    correct: { word: "Tree", emoji: "🌳" },
    distractors: [
      { word: "Ball", emoji: "⚽" },
      { word: "Sun", emoji: "☀️" },
      { word: "Cat", emoji: "🐱" },
    ],
  },
];
